import { useEffect } from 'react';

import { LocalizationProvider } from '@mui/lab';
import AdapterDayjs from '@mui/lab/AdapterDayjs';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import tz from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { SnackbarProvider } from 'notistack';
import { I18nextProvider } from 'react-i18next';

import { setDateFnsLocale } from './date-fns-locale';
import useI18Next from './hooks/useI18Next';
import Loading from './pages/Loading';
import { MsTeamsProvider } from './providers/MsTeamsProvider';
import Routes from './Routes';

dayjs.extend(utc);
dayjs.extend(tz);
dayjs.extend(isSameOrAfter);

const queryClient = new QueryClient();

const App = () => {
    const { loading, error, i18n } = useI18Next();

    useEffect(() => {
        if (i18n?.languages) {
            setDateFnsLocale(i18n.languages[0]);
        }
    }, [i18n.languages]);

    if (loading) {
        return <Loading />;
    }

    if (error) {
        // eslint-disable-next-line
        return <div>Error</div>;
    }

    return (
        <QueryClientProvider client={queryClient}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <I18nextProvider i18n={i18n}>
                    <MsTeamsProvider>
                        <SnackbarProvider anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
                            <Routes />
                        </SnackbarProvider>
                    </MsTeamsProvider>
                </I18nextProvider>
            </LocalizationProvider>
        </QueryClientProvider>
    );
};

export default App;
